import { useState } from 'react';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import {
  OrganizationRegistrationNumberTooltip,
  OrganizationForm,
  type IOrganizationForm,
} from '@/components/Organization';
import { usePartySuggestChanges } from 'src/context/suggest-changes';

const EditDepositorDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    organization: suggestedOrganization,
    partyType,
    setOrganization: setSuggestedOrganization,
  } = usePartySuggestChanges();
  const { softwareEscrow } = useSoftwareEscrow();

  const organization = softwareEscrow[partyType];
  const address = {
    street: suggestedOrganization?.street || organization?.street || '',
    city: suggestedOrganization?.city || organization?.city || '',
    postalCode: suggestedOrganization?.postalCode || organization?.postalCode || '',
    region: suggestedOrganization?.region || organization?.region || '',
    country: suggestedOrganization?.country || organization?.country || '',
  };
  const defaultValues: IOrganizationForm = {
    ...address,
    companyName: suggestedOrganization?.companyName || '',
    companyWebsite: suggestedOrganization?.companyWebsite || '',
    companyRegistration: suggestedOrganization?.companyRegistration || '',
    postalCode: suggestedOrganization?.postalCode || '',
    region: suggestedOrganization?.region || '',
    streetNumber: suggestedOrganization?.streetNumber || '',
  };

  const onSubmit = (formData: IOrganizationForm) => {
    setSuggestedOrganization(formData);
    setIsOpen(false);
  };

  const onCancel = () => setIsOpen(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          Edit
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[976px] gap-0" forceMount>
        <DialogHeader className="mb-6">
          <DialogTitle className="text-base font-bold">Edit organization details</DialogTitle>
          <DialogDescription className="text-xs">
            Enter the details of the organization. This includes the registered name and address of the entity, which
            will be listed in the escrow agreement.
          </DialogDescription>
        </DialogHeader>
        <OrganizationForm
          onSubmit={onSubmit}
          defaultValues={defaultValues}
          onCancel={onCancel}
          registrationTooltip={<OrganizationRegistrationNumberTooltip />}
        />
      </DialogContent>
    </Dialog>
  );
};

export default EditDepositorDialog;
